import {exhaustive} from '@freckle/exhaustive'
import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {H2, Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {
  cardImg,
  cardText,
  programDescription,
  programDescriptionCard,
  programDescriptionContainer,
} from './referral-program.module.scss'

// These steps are based on what we show on the UI
type StepT = 'share' | 'create' | 'earn'

type CardProps = {
  step: StepT
  stepIdx: number // 0-based; the first step has stepIdx 0
}

const getLocizeKeyForCard = (step: StepT): string => {
  switch (step) {
    case 'share':
      return 'REFERRAL_PROGRAM_CARD_SHARE_DESCRIPTION'
    case 'create':
      return 'REFERRAL_PROGRAM_CARD_CREATE_DESCRIPTION'
    case 'earn':
      return 'REFERRAL_PROGRAM_CARD_EARN_DESCRIPTION'
    default:
      return exhaustive(step)
  }
}

const getImagePathForCard = (step: StepT): string => {
  switch (step) {
    case 'share':
      return `${PATHS.imageAssetsUrl}/teacher-dashboard/referral-program/share2.svg`
    case 'create':
      return `${PATHS.imageAssetsUrl}/teacher-dashboard/referral-program/refer2.svg`
    case 'earn':
      return `${PATHS.imageAssetsUrl}/teacher-dashboard/referral-program/premium2.svg`
    default:
      return exhaustive(step)
  }
}

const Card = (props: CardProps) => {
  const {step, stepIdx} = props
  const locizeKey = getLocizeKeyForCard(step)
  const imagePath = getImagePathForCard(step)

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      className={programDescriptionCard}
    >
      <img className={cardImg} src={imagePath} />
      <Text className={cardText}>
        <span>{`${stepIdx + 1}. `}</span>
        <SafeTrans i18nKey={locizeKey} />
      </Text>
    </Flex>
  )
}

const ProgramDescription = (): React.ReactElement => {
  const {t} = useSafeTranslation()
  const steps: Array<StepT> = ['share', 'create', 'earn']

  return (
    <Flex flexDirection="column" alignItems="center" className={programDescriptionContainer}>
      <H2>{t('HOW_IT_WORKS')}</H2>
      <Flex
        flexDirection="row"
        alignItems="stretch"
        justifyContent="center"
        className={programDescription}
      >
        {steps.map((step, idx) => (
          <Card key={step} step={step} stepIdx={idx} />
        ))}
      </Flex>
    </Flex>
  )
}

export {ProgramDescription}
